<template>
  <div class="wrapper">
    <el-dialog
      title="银行支付"
      :visible.sync="dialogVisible"
      width="700px"
      append-to-body
      :before-close="close"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formData"
        :model="formData"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="实际承运人实收运费">
          <el-input v-model="formData.deliveryCashFee" :disabled="true" />
        </el-form-item>
        <el-form-item label="已打款金额">
          <el-input v-model="formData.allotAmount" :disabled="true" />
        </el-form-item>
        <el-form-item label="已分配油点">
          <el-input v-model="formData.allotOil" :disabled="true" />
        </el-form-item>
        <el-form-item label="待打款金额" prop="totalAmount">
          <el-input v-model="formData.totalAmount" type="number" disabled />
        </el-form-item>
        <el-form-item label="平台付款银行">
          <el-input v-model="formData.platformBank" disabled />
        </el-form-item>
        <el-form-item label="平台开户企业">
          <el-input v-model="formData.platformCompanyName" disabled />
        </el-form-item>
        <el-form-item label="平台公户账号">
          <el-input v-model="formData.platformAccount" disabled />
        </el-form-item>
        <el-form-item label="收款方银行">
          <el-input v-model="backData.bankName" disabled />
        </el-form-item>
        <el-form-item label="收款方名称">
          <el-input v-model="backData.name" disabled />
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="20">
            <el-form-item label="获取验证码" prop="verifyCode">
              <el-input
                v-model="formData.verifyCode"
                maxlength="20"
                placeholder="请输入验证码"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple-light">
              <el-button
                v-show="showCode"
                type="primary"
                round
                size="small"
                @click="getCode"
                >获取验证码</el-button
              >
              <span
                v-show="!showCode"
                style="height: 40px;line-height: 40px;display: block;padding-left: 5px;"
                >{{ count }}</span
              >
            </div>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :disabled="updating" @click="submit"
            >确认打款</el-button
          >
        </el-form-item>
      </el-form>
      <vxe-table border height="250" :data="tableData" auto-resize>
        <vxe-table-column
          field="orderDetailNumber"
          title="运单号"
          min-width="260"
        />
        <vxe-table-column field="amount" title="分配现金" min-width="100" />
        <vxe-table-column field="gmtCreated" title="分配时间" min-width="220" />
      </vxe-table>
      <vxe-pager
        :loading="loading"
        :page-sizes="Pagingconf"
        :current-page.sync="formPage.pageNum"
        :page-size.sync="formPage.pageSize"
        :total="formPage.total"
        :layouts="[
          'PrevJump',
          'PrevPage',
          'Number',
          'NextPage',
          'NextJump',
          'Sizes',
          'FullJump',
          'Total'
        ]"
        @page-change="handlePageChange"
      />
    </el-dialog>
  </div>
</template>

<script>
import {
  checkDriverBankCard,
  loginUserDefaultHousehold,
  remitDefinite
} from "@/api/transport";
import {
  sendCentralCode,
  centralPayment,
  batchCentralPayment
} from "@/api/InternetBanking";
export default {
  props: {
    parentData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      updating: true,
      showCode: true,
      tableData: [],
      row: {},
      formData: {
        codes: [],
        orderNo: "",
        payeeCode: "",
        payReceiptImg: "",
        createdTime: "",
        platformBank: "",
        platformCompanyName: "",
        platformAccount: ""
      },
      backData: {
        platformBank: "",
        platformCompanyName: "",
        platformAccount: ""
      },
      rules: {
        verifyCode: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      },
      formPage: {
        payTypes: "3,4,5,9,10",
        orderDetailCode: "",
        pageNum: 1,
        pageSize: 20,
        totaltotal: 0,
        payerRole: 0
      },
      Pagingconf: [20, 30, 50, 100],
      count: 0
    };
  },
  created() {},
  methods: {
    show(ismore) {
      this.ismore = ismore;
      this.formData = Object.assign({}, this.parentData);
      this.paymentType = this.parentData.paymentType;
      this.findList();
      this.Allocationrecord();
    },
    // 获取/查询 列表
    async findList() {
      if (this.parentData) {
        const rLoading = this.openLoading();
        let response_l = await loginUserDefaultHousehold({
          branchCode: this.parentData.branchCode,
          type: 0
        });
        if (!response_l.data) {
          rLoading.close();
          this.$message.error("当前机构没有默认公户无法打款");
          return;
        }
        let response = await checkDriverBankCard(
          this.parentData.payeeCode,
          this.formData.codes.toString()
        );
        rLoading.close();
        if (!response.data) {
          this.$message.error("当前银企收款人没有绑定银行卡无法打款！");
          return;
        }
        this.dialogVisible = true;
        this.backData = response.data;
        this.formData.platformBank = response_l.data.bankName;
        this.formData.platformCompanyName = response_l.data.companyName;
        this.formData.platformAccount = response_l.data.bankNum;
        this.formData.payeePhone = this.backData.phone;
      } else {
        this.$message.error("没有选中打款实际承运人！");
        return;
      }
    },
    //获取验证码
    async getCode() {
      let form = {
        partyGroupCode: this.formData.branchCode,
        orderDetailNumber: this.formData.orderDetailNumber
      };
      form.type = this.ismore ? "1" : "0";
      const rLoading = this.openLoading();
      let response = await sendCentralCode(form);
      rLoading.close();
      this.$message.success(response.msg);
      this.updating = false;
      if (response.status == 0) {
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.showCode = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.showCode = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    // 提交
    submit() {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          const rLoading = this.openLoading();
          let response = this.ismore
            ? await batchCentralPayment(this.formData)
            : await centralPayment(this.formData);
          rLoading.close();
          this.$message.success(response.msg);
          this.$emit("onSuccess");
          this.updating = true;
          this.count = 0;
          this.dialogVisible = false;
        }
      });
    },
    // 记录列表
    Allocationrecord() {
      this.tableData = [];
      this.loading = true;
      this.formPage.orderDetailCode = this.formData.orderDetailNumber;
      remitDefinite(this.formPage).then(response => {
        this.tableData = response.data.records;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.formPage.total = response.data.total;
        this.loading = false;
      });
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.formPage.pageNum = currentPage;
      this.formPage.pageSize = pageSize;
      this.Allocationrecord();
    },
    // 关闭
    close() {
      this.$refs.formData.resetFields();
      this.showCode = true;
      this.count = 0;
      this.dialogVisible = false;
    }
  }
};
</script>
<style scoped>
.bg-purple-light {
  margin-left: 10px;
}
</style>
